import { render, staticRenderFns } from "./ZyroRibbon.vue?vue&type=template&id=5e6c3dd0&scoped=true&"
import script from "./ZyroRibbon.vue?vue&type=script&lang=js&"
export * from "./ZyroRibbon.vue?vue&type=script&lang=js&"
import style0 from "./ZyroRibbon.vue?vue&type=style&index=0&id=5e6c3dd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6c3dd0",
  null
  
)

export default component.exports